module.exports = __webpack_public_path__ + "media/social/tiktok-icon-small-e0f1bac0.svg";